import { components } from 'react-select'

// TODO This component is not used. However, it is a pretty clever modal and
//  might be used in the future. Therefore keeping it as is.
const ShowAllResults = ({ onClick, ...props }) => (
    <components.MenuList {...props}>
        {props.children}
        <button className="select__show-all-results" onClick={onClick}>
            <T>input.placeholder.show.all.results</T>
        </button>
    </components.MenuList>
)

export default ShowAllResults
